import { render, staticRenderFns } from "./GameForm.vue?vue&type=template&id=19738378&"
import script from "./GameForm.vue?vue&type=script&lang=js&"
export * from "./GameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports